import common from '../common/common'
import fetch from "../common/util"


export default {
    // 用户登录
    userLogin: function (params) {
        return fetch.get(common.GetAppVar().A_USER_LOGIN, params);
    },
    // 用户信息
    getUserInfo: function (uid) {
        return fetch.get(common.GetAppVar().A_USER_INFO + '/' + uid);
    },
    // 修改资料
    editInfo: function (params) {
        return fetch.get(common.GetAppVar().A_USER_EDIT, params);
    },
    // 发送验证码
    sendCode: function (params) {
        return fetch.get(common.GetAppVar().A_SEND_CODE, params);
    },
    // 修改密码
    changePwd: function (params) {
        return fetch.get(common.GetAppVar().A_CHANGE_PWD, params);
    },
    // 站内消息
    searchNotice: function (uid, pageNum) {
        let params = {
            user_id: uid,
            page: pageNum,
            page_size: 10,
        }
        return fetch.get(common.GetAppVar().A_USER_NOTICE, params);
    },
    // VCC
    vccList: function (params) {
        return fetch.get(common.GetAppVar().A_CARD_LIST, params);
    },

    getCNY: function (currency_type, amount) {
        return fetch.get(common.GetAppVar().A_GET_CNY_MONEY, { "currency_type": currency_type, "amount": amount });
    },
		
    addVCC: function (params) {
        return fetch.get(common.GetAppVar().A_APPLY_CARD, params);
    },
	
	getCVV: function (agentId) {
        return fetch.get(common.GetAppVar().A_GET_VCC_CONTENT, { "vcc_id": agentId });
    },

    vccDetail: function (agentId) {
        return fetch.get(common.GetAppVar().A_CARD_DETAIL, { "vcc_id": agentId });
    },

    // 代理相关
    agentList: function (params) {
        return fetch.get(common.GetAppVar().A_AGENT_LIST, params);
    },

    addAgent: function (params) {
        return fetch.get(common.GetAppVar().A_AGENT_ADD, params);
    },

    agentDetail: function (agentId) {
        return fetch.get(common.GetAppVar().A_AGENT_DETAIL, { "agent_id": agentId });
    },

    agentChangePass: function (agentId) {
        return fetch.get(common.GetAppVar().A_AGENT_PASS, { "agent_id": agentId });
    },

    agentChangePerc: function (agentId, agentPerc) {
        return fetch.get(common.GetAppVar().A_AGENT_PERCENT, { "agent_id": agentId, "agent_percent": agentPerc });
    },

}


// WEBPACK FOOTER //
// ./src/api/user.js